var version = {
    "name":      "dativery",
    "buildDateCode": "20260610-101351",
    "buildDate": "Wed Jun 10 2026 10:13:51 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260610-101351",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;